import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IPrices } from '../../models/common.models';
import { ILabelAttributes, IProductLabel } from '../../models/abstract-product.models';
import { PriceUtils } from '../../utils/price.utils';

@Component({
  selector: 'app-sticker',
  templateUrl: './sticker.component.html',
  styleUrls: ['./sticker.component.scss'],
  standalone: false,
})
export class StickerComponent implements OnInit {
  label!: ILabelAttributes;
  labelId: string = '';
  hasLabel: boolean = false;
  @Input() product: any;
  @Input() isCatalog!: boolean;
  @Input() prices!: IPrices[];
  @Input() labels!: IProductLabel[];

  hasProductLabels: boolean = false;

  ngOnInit(): void {
    this.hasProductLabels = Object.hasOwn(this.product, 'product-labels');

    if (this.labelsExists()) {
      this.setLabel();
    }
  }

  setLabel(): void {
    if (this.isCatalog && this.hasProductLabels) {
      this.labelId = this.product['product-labels'].data[0].id;
    } else {
      this.labelId = this.product.relationships['product-labels'].data[0].id;
    }
    const foundLabel: IProductLabel | undefined = this.labels.find(label => label.id === this.labelId);
    if (!foundLabel) {
      return;
    }
    this.label = foundLabel.attributes;

    if (environment.discountStickers.includes(this.label?.frontEndReference?.toLocaleUpperCase())) {
      this.label = {
        ...this.label,
        name: this.getDiscountLabel()
      };
    }

    this.hasLabel = !!this.label?.name;
  }

  private getDiscountLabel(): string {
    if (!this.prices) {
      return '';
    }
    const discountPrice: number | undefined = PriceUtils.getPriceValue(PriceUtils.getDefaultPrice(this.prices));
    const standardPrice: number | undefined = PriceUtils.getPriceValue(PriceUtils.getGuestPrice(this.prices));

    return this.getDiscountValue(discountPrice, standardPrice);
  }

  labelsExists(): boolean {
    if (this.isCatalog && this.product && this.hasProductLabels) {
      return this.product['product-labels'].data.length > 0;
    }

    if (!this.product?.relationships || !this.product.relationships['product-labels']) {
      return false;
    }

    return this.product.relationships['product-labels']?.data.length > 0;
  }

  private getDiscountValue(discountPrice?: number, standardPrice?: number): string {
    if (discountPrice === undefined || standardPrice === undefined) {
      return '';
    }
    const percentage: number = (discountPrice / standardPrice) * 100;
    const rounded: number = Math.round(percentage);

    return rounded <= 95 ? `${100 - rounded} %` : '';
  }
}
